import React, { useState, useEffect } from "react";
import NavBar from "../components/navbar";
import Footer from "../components/footer";
import { useSelector, useDispatch } from "react-redux";
import { saveShippingAddress } from "../actions/cartActions";
import CheckoutSteps from "../components/checkoutSteps";

function ShippingPage(props) {
  const userSignin = useSelector((state) => state.userSignin);
  const { userInfo } = userSignin;
  const cart = useSelector((state) => state.cart);
  const { shippingAddress } = cart;
  if (!userInfo) {
    props.history.push("/signin");
  }

  const [fullName, setFullName] = useState(shippingAddress.fullName);
  const [address, setAddress] = useState(shippingAddress.address);
  const [city, setCity] = useState(shippingAddress.city);
  const [zipcode, setZipcode] = useState(shippingAddress.zipcode);
  const [country, setCountry] = useState(shippingAddress.country);

  const dispatch = useDispatch();

  const submitHandler = (e) => {
    e.preventDefault();
    dispatch(
      saveShippingAddress({ fullName, address, city, zipcode, country })
    );
    props.history.push("/payment");
  };

  return (
    <div>
      <NavBar />
      <div className="container">
        <CheckoutSteps step1 step2 />
        <div className="row justify-content-center">
          <form
            className="shipping mt-5 mb-5 col col-10 col-lg-8 "
            onSubmit={submitHandler}
          >
            <div className="mb-4">
              <h3>Shipping Address</h3>
            </div>

            <div className="mb-3">
              <label htmlFor="fullName" className="form-label">
                Full Name
              </label>
              <input
                type="text"
                className="form-control "
                id="fullName"
                value={fullName}
                required
                placeholder="Enter full name"
                onChange={(e) => setFullName(e.target.value)}
              />
            </div>

            <div className="mb-3">
              <label htmlFor="address" className="form-label">
                Address
              </label>
              <input
                type="text"
                placeholder="Enter address"
                className="form-control "
                id="address"
                value={address}
                required
                onChange={(e) => setAddress(e.target.value)}
              />
            </div>
            <div className="mb-3">
              <label htmlFor="city" className="form-label">
                City
              </label>
              <input
                type="text"
                value={city}
                className="form-control "
                id="city"
                required
                placeholder="Enter city"
                onChange={(e) => setCity(e.target.value)}
              />
            </div>
            <div className="mb-3">
              <label htmlFor="zipcode" className="form-label">
                Zipcode
              </label>
              <input
                type="text"
                value={zipcode}
                className="form-control "
                placeholder="Enter zip code"
                id="zipcode"
                required
                onChange={(e) => setZipcode(e.target.value)}
              />
            </div>
            <div className="mb-3">
              <label htmlFor="country" className="form-label">
                Country
              </label>
              <input
                type="text"
                value={country}
                placeholder="Enter country"
                className="form-control "
                id="country"
                required
                onChange={(e) => setCountry(e.target.value)}
              />
            </div>

            <div className="mb-3 d-flex justify-content-center">
              <button type="submit " className="btn btn-warning mt-3her">
                Continue
              </button>
            </div>
          </form>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default ShippingPage;

// function ShippingPage(props) {
//   const [fullname, setFullname] = useState("");
//   const [address, setAddress] = useState("");
//   const [city, setCity] = useState("");
//   const [zipcode, setZipcode] = useState("");
//   const [country, setCountry] = useState("");

//   const dispatch = useDispatch();

//   const submitHandler = (e) => {
//     e.preventDefault();
//     dispatch(saveShipping({ fullname, address, city, zipcode, country }));
//     props.history.push("/payment");
//   };

//   return (
//     <div>
//       <NavBar />
//       <div className="container">
//         <CheckoutSteps step1 step2 />
//         <div className="row justify-content-center">
//           <form
//             className="signin mt-5 mb-5 col col-lg-4 "
//             onSubmit={submitHandler}
//           >
//             <div className="mb-4">
//               <h3>Shipping Address</h3>
//             </div>

//             <div className="mb-3">
//               <label htmlFor="fullname" className="form-label">
//                 Full Name
//               </label>
//               <input
//                 type="text"
//                 name="fullnam"
//                 className="form-control "
//                 id="fullnam"
//                 onChange={(e) => setFullname(e.target.value)}
//               />
//             </div>

//             <div className="mb-3">
//               <label htmlFor="address" className="form-label">
//                 Address
//               </label>
//               <input
//                 type="text"
//                 name="address"
//                 className="form-control "
//                 id="address"
//                 onChange={(e) => setAddress(e.target.value)}
//               />
//             </div>
//             <div className="mb-3">
//               <label htmlFor="city" className="form-label">
//                 City
//               </label>
//               <input
//                 type="text"
//                 name="city"
//                 className="form-control "
//                 id="city"
//                 onChange={(e) => setCity(e.target.value)}
//               />
//             </div>
//             <div className="mb-3">
//               <label htmlFor="zipcode" className="form-label">
//                 Zipcode
//               </label>
//               <input
//                 type="text"
//                 name="zipcode"
//                 className="form-control "
//                 id="zipcode"
//                 onChange={(e) => setZipcode(e.target.value)}
//               />
//             </div>
//             <div className="mb-3">
//               <label htmlFor="country" className="form-label">
//                 Country
//               </label>
//               <input
//                 type="text"
//                 name="country"
//                 className="form-control "
//                 id="country"
//                 onChange={(e) => setCountry(e.target.value)}
//               />
//             </div>

//             <div className="mb-3 ">
//               <button type="submit" className="btn btn-warning ">
//                 Continue
//               </button>
//             </div>
//           </form>
//         </div>
//       </div>

//       <Footer />
//     </div>
//   );
// }

// export default ShippingPage;
